export default "__VITE_ASSET__CY_rj3YM__"